<template>
  <article class="tile is-child box">
    <p class="subtitle ">{{ title }}</p>
    <nav class="level is-mobile">
      <div class="level-item has-text-centered">
        <div>
          <p class="is-size-6">{{ labels.votesUp }}</p>
          <p class="title thumbup">{{ stats.up_votes }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="is-size-6">{{ labels.votesOk }}</p>
          <p class="title thumbok">{{ stats.ok_votes }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="is-size-6">{{ labels.votesDown }}</p>
          <p class="title thumbdown">{{ stats.down_votes }}</p>
        </div>
      </div>
    </nav>
  </article>
</template>

<script>
export default {
  name: "StatsCard",
  props: {
    title: {
      type: String,
      required: true,
      default: ""
    },
    stats: {
      type: Object,
      required: true,
    },
    labels: {
      type: Object,
      required: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
